module.exports = __webpack_public_path__ + "img/envelope_icon_white.0fcc23e3.svg";